import { StorageObjectState } from "../../storageObjectSlice/types";
import { APP_UI_STATE } from "../constants";
import { TUiApp } from "../types";

export const getUiInitialState = (
  servicesArray: (keyof StorageObjectState)[],
): TUiApp => {
  const storedState = localStorage.getItem(APP_UI_STATE);

  if (storedState) {
    try {
      const parsed = JSON.parse(storedState);
      if (parsed && typeof parsed === "object") {
        const missingService = servicesArray.filter(
          (service) => !Object.hasOwn(parsed, service),
        );
        if (missingService.length === 0) {
          return parsed as TUiApp;
        }

        const updatedState = missingService.reduce(
          (acc, service) => ({
            ...acc,
            [service]: {
              sidebar: {
                width: 260,
                isOpen: true,
              },
            },
          }),
          parsed as TUiApp,
        );
        localStorage.setItem(APP_UI_STATE, JSON.stringify(updatedState));
        return updatedState;
      }
    } catch (e) {
      console.warn("Failed to parse UI state, resetting to default", e);
      localStorage.removeItem(APP_UI_STATE);
    }
  }

  const defaultState = servicesArray.reduce((acc, service) => {
    return {
      ...acc,
      [service]: {
        sidebar: {
          width: 260,
          isOpen: true,
        },
      },
    };
  }, {} as TUiApp);

  localStorage.setItem(APP_UI_STATE, JSON.stringify(defaultState));

  return defaultState;
};
